/// <amd-module name="VSS/Features/PlatformUI/Components/ContributedButton/ContributedButton" />
import * as React from "react";

import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

import { Button, IButtonProps } from "VSSUI/Button";
import { ButtonGroup } from "VSSUI/ButtonGroup";

import { contributedIconToIconProps } from "../ContributedIcon/ContributedIcon";
import { IContributedButton, IContributedButtonGroupProps } from "./ContributedButton.Props";

/**
 * Translates the "icon" property from a contribution to IIconProps that can be used to render the contribution's icon
 *
 * @param pageContext
 * @param contributionId
 * @param iconProperty
 */
export function contributedButtonToButtonProps(pageContext: IVssPageContext, contributedButtonProps: IContributedButton): IButtonProps {
    const props: IButtonProps = {
        disabled: contributedButtonProps.disabled,
        href: contributedButtonProps.href,
        primary: contributedButtonProps.primary,
        target: contributedButtonProps.target,
        text: contributedButtonProps.text
    };

    if (contributedButtonProps.tooltip) {
        props.ariaLabel = contributedButtonProps.tooltip;
        props.tooltipProps = { text: contributedButtonProps.tooltip };
    }

    if (contributedButtonProps.href && contributedButtonProps.target) {
        props.rel = "noopener noreferrer";
    }

    if (contributedButtonProps.icon) {
        props.iconProps = contributedIconToIconProps(pageContext, contributedButtonProps.contributionId, contributedButtonProps.icon);
    }

    if (contributedButtonProps.command) {
        props.onClick = () => {
            const args = contributedButtonProps.commandArguments || [];
            if (typeof contributedButtonProps.command === "string") {
                const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
                contributionService.executeCommand(contributedButtonProps.command, ...args);
            } else if (contributedButtonProps.contributionId) {
                const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
                contributionService.executeCommandEx(contributedButtonProps.contributionId, contributedButtonProps.command!, ...args);
            }
        };
    }

    return props;
}

/**
 * Renders a group of buttons based off contributions
 */
export function ContributedButtonGroup(props: IContributedButtonGroupProps): JSX.Element | null {
    const { pageContext, className, buttons } = props;
    return (
        <ButtonGroup className={className}>
            {buttons.map(button => (
                <Button {...contributedButtonToButtonProps(pageContext, button)} />
            ))}
        </ButtonGroup>
    );
}
